export default {
      id: "oc-kongzhitai-usage",
      viewBox: "0 0 1194 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-kongzhitai",
      toString: function () {
        return this.url;
      }
    }